export const SITE_URL = 'https://www.workwearexpress.com';

export const ORGANIZATION_ID = `${SITE_URL}/#organization`;

export const WEBSITE_ID = `${SITE_URL}/#website`;

export const breadcrumbSchemaId = (canonicalUrl: string): string => `${canonicalUrl}#breadcrumb`;
